import { render, staticRenderFns } from "./TermsOfUse.html?vue&type=template&id=fdf1b688&scoped=true&"
import script from "./TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUse.scss?vue&type=style&index=0&id=fdf1b688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf1b688",
  null
  
)

export default component.exports